import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {AuthProvider} from './contexts/AuthContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Layout from "./components/Layout";

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    {/* Öffentliche Seite */}
                    <Route path="/" element={<LandingPage/>}/>

                    {/* Login Seite (nur für nicht angemeldete) */}
                    <Route path="/login" element={
                        <PublicRoute>
                            <LoginPage/>
                        </PublicRoute>
                    }/>

                    {/* Dashboard Seite (nur für angemeldete) */}
                    <Route path="/dashboard" element={
                        <ProtectedRoute>
                            <Layout>
                                <DashboardPage/>
                            </Layout>
                        </ProtectedRoute>
                    }/>

                    {/* Catch-all Route: Weiterleitung zum Dashboard, falls angemeldet, sonst Login */}
                    <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;